import { render, staticRenderFns } from "./q-pop-success.vue?vue&type=template&id=b5e06820&scoped=true&"
import script from "./q-pop-success.vue?vue&type=script&lang=js&"
export * from "./q-pop-success.vue?vue&type=script&lang=js&"
import style0 from "./q-pop-success.vue?vue&type=style&index=0&id=b5e06820&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e06820",
  null
  
)

export default component.exports